import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { HomePage } from '../home/home';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  difficulty: string;
  language: string;

  constructor(public smartAudio: SmartAudio, public rubedoSideMenu: MenuController, public functions: Functions, public translate: TranslateService, public navCtrl: NavController, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.difficulty = '';
    this.language = '';
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setDifficulty();
    this.functions.setLanguage();
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getDifficulty();
    this.functions.getLanguage();
  }

  /* --------- END IFECYCLE --------- */
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts